module.exports = __webpack_public_path__ + "img/compare2.7f693366.svg";